/**
 * ESM shim for shared-components/search-module/data/time-data.js
 *
 * shared-components is a submodule (cannot be edited). That file uses CJS
 * exports.TimeMap = which Vite can't treat as ESM named exports since
 * shared-components is excluded from @rollup/plugin-commonjs transformation.
 */
export const TimeMap = {
  0: { time_index: 0, time: "6:00 am", h: 6, m: 0, overnight: false },
  1: { time_index: 1, time: "6:30 am", h: 6, m: 30, overnight: false },
  2: { time_index: 2, time: "7:00 am", h: 7, m: 0, overnight: false },
  3: { time_index: 3, time: "7:30 am", h: 7, m: 30, overnight: false },
  4: { time_index: 4, time: "8:00 am", h: 8, m: 0, overnight: false },
  5: { time_index: 5, time: "8:30 am", h: 8, m: 30, overnight: false },
  6: { time_index: 6, time: "9:00 am", h: 9, m: 0, overnight: false },
  7: { time_index: 7, time: "9:30 am", h: 9, m: 30, overnight: false },
  8: { time_index: 8, time: "10:00 am", h: 10, m: 0, overnight: false },
  9: { time_index: 9, time: "10:30 am", h: 10, m: 30, overnight: false },
  10: { time_index: 10, time: "11:00 am", h: 11, m: 0, overnight: false },
  11: { time_index: 11, time: "11:30 am", h: 11, m: 30, overnight: false },
  12: { time_index: 12, time: "12:00 pm", h: 12, m: 0, overnight: false },
  13: { time_index: 13, time: "12:30 pm", h: 12, m: 30, overnight: false },
  14: { time_index: 14, time: "1:00 pm", h: 13, m: 0, overnight: false },
  15: { time_index: 15, time: "1:30 pm", h: 13, m: 30, overnight: false },
  16: { time_index: 16, time: "2:00 pm", h: 14, m: 0, overnight: false },
  17: { time_index: 17, time: "2:30 pm", h: 14, m: 30, overnight: false },
  18: { time_index: 18, time: "3:00 pm", h: 15, m: 0, overnight: false },
  19: { time_index: 19, time: "3:30 pm", h: 15, m: 30, overnight: false },
  20: { time_index: 20, time: "4:00 pm", h: 16, m: 0, overnight: false },
  21: { time_index: 21, time: "4:30 pm", h: 16, m: 30, overnight: false },
  22: { time_index: 22, time: "5:00 pm", h: 17, m: 0, overnight: false },
  23: { time_index: 23, time: "5:30 pm", h: 17, m: 30, overnight: false },
  24: { time_index: 24, time: "6:00 pm", h: 18, m: 0, overnight: false },
  25: { time_index: 25, time: "6:30 pm", h: 18, m: 30, overnight: false },
  26: { time_index: 26, time: "7:00 pm", h: 19, m: 0, overnight: false },
  27: { time_index: 27, time: "7:30 pm", h: 19, m: 30, overnight: false },
  28: { time_index: 28, time: "8:00 pm", h: 20, m: 0, overnight: false },
  29: { time_index: 29, time: "8:30 pm", h: 20, m: 30, overnight: false },
  30: { time_index: 30, time: "9:00 pm", h: 21, m: 0, overnight: false },
  31: { time_index: 31, time: "9:30 pm", h: 21, m: 30, overnight: false },
  32: { time_index: 32, time: "10:00 pm", h: 22, m: 0, overnight: false },
  33: { time_index: 33, time: "10:30 pm", h: 22, m: 30, overnight: false },
  34: { time_index: 34, time: "11:00 pm", h: 23, m: 0, overnight: false },
  35: { time_index: 35, time: "11:30 pm", h: 23, m: 30, overnight: false },
  36: { time_index: 36, time: "12:00 am*", h: 0, m: 0, overnight: true },
  37: { time_index: 37, time: "12:30 am*", h: 0, m: 30, overnight: true },
  38: { time_index: 38, time: "1:00 am*", h: 1, m: 0, overnight: true },
  39: { time_index: 39, time: "1:30 am*", h: 1, m: 30, overnight: true },
  40: { time_index: 40, time: "2:00 am*", h: 2, m: 0, overnight: true },
  41: { time_index: 41, time: "2:30 am*", h: 2, m: 30, overnight: true },
  42: { time_index: 42, time: "3:00 am*", h: 3, m: 0, overnight: true },
  43: { time_index: 43, time: "3:30 am*", h: 3, m: 30, overnight: true },
  44: { time_index: 44, time: "4:00 am*", h: 4, m: 0, overnight: true },
  45: { time_index: 45, time: "4:30 am*", h: 4, m: 30, overnight: true },
  46: { time_index: 46, time: "5:00 am*", h: 5, m: 0, overnight: true },
  47: { time_index: 47, time: "5:30 am*", h: 5, m: 30, overnight: true },
  48: { time_index: 48, time: "6:00 am*", h: 6, m: 0, overnight: true },
};
